import get from 'lodash/get';
// import { behaviors as GuideItemBehaviors } from '../guideItemTypes';

export default function isPlayable(guideItem) {
  // TODO: Talk to platfom whether we should be using behaviors.default.actionName = Play
  // return get(guideItem, 'behaviors.default.actionName') === GuideItemBehaviors.play
  return (
    !!(
      get(guideItem, 'actions.play.canPlay') &&
      get(guideItem, 'actions.play.guideId')
    ) && !get(guideItem, 'actions.play.subscriptionRequired')
  );
}
